const intNum = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export const inputPosInt = (event: React.KeyboardEvent<HTMLInputElement>) => {
  if (!intNum.includes(event.key)) {
    event.preventDefault();
  }
};

export const inputPosDecimal = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const v = (event.target as HTMLInputElement).value;
  if (
    (!intNum.includes(event.key) && event.key !== '.') ||
    (event.key === '.' && v.includes('.'))
  ) {
    event.preventDefault();
  }
};

export const limitPrecision = (value: number, precisionInt: number) => {
  const preci = 10 ** precisionInt;
  return {
    precisionMatch: value * preci === Math.floor(value * preci),
    precisionVal: parseFloat(((value * preci) / preci).toFixed(precisionInt)),
  };
};
